import {Injectable} from "@angular/core";
import {ApiService} from "./api.service";
import {AuthenticateDto} from "../models/authenticate-dto";
import {HttpErrorResponse} from "@angular/common/http";


@Injectable()
export class Auth2Service {

  contextApi = '/api';

  constructor(private apiService : ApiService) {

  }

  public authenticate(authDto: AuthenticateDto): any {
    return this.apiService.postCall(this.contextApi + '/public/auth/users/authenticate',
      authDto,
      false,
      false,
      true
    );
  }

  public authenticateV2(authDto: AuthenticateDto): any {
    return this.apiService.postCall(this.contextApi + '/public/auth/users/authenticate/v2',
      authDto,
      false,
      false,
      true
    );
  }

  public refreshToken(): void {
    this.apiService.postCall(this.contextApi + '/protected/auth/users/authenticate/v2',
      {
        refresh_token: sessionStorage.getItem('refreshToken')
      },
      false,
      true,
      true
    ).subscribe((result: any) => {
      if (result && result.body) {
        this.cacheSessionFull(result.body);
      }
    }, (error : HttpErrorResponse) => {
      console.log('Could not refresh token...')
    });
  }

  public isUserAuthenticated(): any {

    return this.apiService.postCall(this.contextApi + '/public/auth/users/status/v2',
      {
        idToken: localStorage.getItem('idToken'),
        refreshToken: localStorage.getItem('refreshToken'),
        username: localStorage.getItem('username'),
      },
      false,
      false,
      true
    );
  }

  public isLoggedIn(): any {
    return true
  }

  public getUserId(): string {
    // @ts-ignore
    return localStorage.getItem('userId');
  }
  public getUsername(): string {
    // @ts-ignore
    return localStorage.getItem('username');
  }

  public getIdToken(): string {
    // @ts-ignore
    return localStorage.getItem('idToken');
  }

  public getRefreshToken(): string {
    // @ts-ignore
    return localStorage.getItem('refreshToken');
  }

  public getExpiresIn(): string {
    // @ts-ignore
    return localStorage.getItem('expiresIn');
  }

  public getExp(): string {
    // @ts-ignore
    return localStorage.getItem('exp');
  }

  public getIsConsultant(): string {
    // @ts-ignore
    return localStorage.getItem('isConsultant');
  }

  public getImpersonatedEmail(): string {
    // @ts-ignore
    return localStorage.getItem('impersonatedEmail');
  }

  public setImpersonatedEmail(impersonatedEmail: string): string {
    // @ts-ignore
    return localStorage.setItem('impersonatedEmail', impersonatedEmail);
  }

  public removeImpersonatedEmail(): string {
    // @ts-ignore
    return localStorage.removeItem('impersonatedEmail');
  }

  public getConsultantRoleName(): string {
    // @ts-ignore
    return localStorage.getItem('consultantRoleName');
  }

  public setConsultantRoleName(consultantRoleName: string): string {
    // @ts-ignore
    return localStorage.setItem('consultantRoleName', consultantRoleName);
  }

  public getEmailCodeVerifiedFlag(): string {
    // @ts-ignore
    return localStorage.getItem('emailCodeVerifiedFlag');
  }

  public setEmailCodeVerifiedFlag(flag: string): string {
    // @ts-ignore
    return localStorage.setItem('emailCodeVerifiedFlag', flag);
  }

  public removeConsultantRoleName(): string {
    // @ts-ignore
    return localStorage.removeItem('consultantRoleName');
  }

  public cacheSessionFull(authBody: any): void {
    localStorage.setItem('userId', authBody.userId);
    localStorage.setItem('username', authBody.email);
    localStorage.setItem('isConsultant', authBody.isConsultant);
    localStorage.setItem('idToken', authBody.idToken);
    localStorage.setItem('refreshToken', authBody.refreshToken);
    localStorage.setItem('expiresIn', authBody.expiresIn)
    localStorage.setItem('exp', authBody.exp)
    localStorage.setItem('emailCodeVerifiedTs', authBody.emailCodeVerifiedTs)
    localStorage.setItem('emailCodeVerifiedExpirationTs', authBody.emailCodeVerifiedExpirationTs)
    localStorage.setItem('emailCodeVerifiedFlag', authBody.emailCodeVerifiedFlag)
  }

  /*
  public cacheSessionShort(refreshSessionBody: any): void {
    localStorage.setItem('username', refreshSessionBody.username);
    localStorage.setItem('idToken', refreshSessionBody.idToken);
    localStorage.setItem('refreshToken', refreshSessionBody.refreshToken);
  }*/

  public cleanOutSession(): void {
    localStorage.removeItem('userId');
    localStorage.removeItem('username');
    localStorage.removeItem('isConsultant');
    localStorage.removeItem('impersonatedEmail');
    localStorage.removeItem('consultantRoleName');
    localStorage.removeItem('idToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('expiresIn');
    localStorage.removeItem('exp');
  }
  public logout(): any {
    return this.apiService.putCall(this.contextApi + '/protected/auth/users/logout/v2?loggedInUsername=' + this.getUsername(),
      null,
      false,
      true,
      true
    );
  }
}
